// lib
import { batch } from "react-redux";
// src
import { qualifyEnableds } from "utils/presets";
import * as sync from "./index";
import * as tableSync from "../table";
import { FetchType, managedFetchEvents } from "./fetcher";

export const computeDisplay = () => (dispatch, getState) => {
  const qualifiedEnableds = qualifyEnableds(getState().presets);
  dispatch(sync.recompute({ enableds: qualifiedEnableds }));
};

export const fetchEnableds = () => async (dispatch, getState) => {
  // do not block UX after updateRange (especially impacting when using cache)
  setTimeout(() => {
    const { dateStart, dateEnd } = getState().table;
    // Light enabled takes priority over enableds
    const qualifiedEnableds = qualifyEnableds(getState().presets);
    const allFetchedInSync = qualifiedEnableds
      .map((preset) =>
        managedFetchEvents(dispatch, getState, preset, dateStart, dateEnd, computeDisplay),
      )
      .every((fetchType) => fetchType === FetchType.SYNC);
    if (allFetchedInSync) {
      const { dateStart: tableDateStart, dateEnd: tableDateEnd } = getState().table;
      batch(() => {
        dispatch(computeDisplay());
        dispatch(sync.cacheEvents({ dateStart: tableDateStart, dateEnd: tableDateEnd }));
      });
    }
  }, 0);
};

export const updateRangeAndFetch = (dateStart, dateEnd) => async (dispatch) => {
  dispatch(tableSync.updateRange({ dateStart, dateEnd }));
  dispatch(fetchEnableds());
};

export const updateFocusAndFetch = (focus) => async (dispatch, getState) => {
  const { view } = getState().table;
  dispatch(tableSync.updateFocus({ focus, view }));
  // timeline has its own optimization on when it should fetch
  if (view !== "timeline") dispatch(fetchEnableds());
};
